import styled from 'styled-components'

export const ActionsDashboardRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-top: 20px;
`

export const ActionsCardWrapper = styled.div`
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 20px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const ActionsCardTitle = styled.div`
  font-size: 18px;
  line-height: 22px;
  font-weight: 600;
  color: #111827;
`

export const ActionsCount = styled.div`
  font-size: 40px;
  line-height: 40px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 4px;
`

export const ActionItemsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const ActionListItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  color: #111827;
`
